<template>

<div class="row">

    <div class="col-4">
        <button @click='openModal' class='btn btn-success btn-block'>
           Вашата оценка за изпълнението
        </button>
    </div>

    <div class="modal" id="wrmdl">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">

                <div class="modal-header">
                    <h4 class="modal-title">
                        Ревю за изпълнителя
                    </h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>

                <div class="modal-body">
                    <loading-div v-if='!isReady'></loading-div>

                    <div v-if='isReady' class='col-12'>
                        
                        <div class='row'>
                            <div class="col-4">
                                <label for='c1'>
                                    <strong class="d-block"> Изисквания: ( {{ model.c1 }} / 5 ) </strong>
                                    <small>До каква степен изпълнителя спази изискванията?</small>
                                </label>
                                <input id='c1' class='custom-range pl-0 pr-0' type='range' min=1 max=5 v-model.number='model.c1'>
                            </div>
                            <div class="col-4">
                                <label for='c2'>
                                    <strong class="d-block"> Качество: ( {{ model.c2 }} / 5 ) </strong>
                                    <small>Какво е качеството на изпълнената работа?</small>
                                </label>
                                <input id='c2' class='custom-range pl-0 pr-0' type='range' min=1 max=5 v-model.number='model.c2'>
                            </div>
                            <div class="col-4">
                                <label for='c3'>
                                    <strong class="d-block"> Срок: ( {{ model.c3 }} / 5 ) </strong>
                                    <small>Спази ли срока, за който трябваше да бъде извършена работата?</small>
                                </label>
                                <input id='c3' class='custom-range pl-0 pr-0' type='range' min=1 max=5 v-model.number='model.c3'>
                            </div>

                            <div class="col-12 mt-4 text-center">
                                <h4> Обща оценка: {{ model.rating }} </h4>
                            </div>

                            <div class="col-12 mt-20">
                                <label for='review'>
                                    <strong class="d-block"> Вашето ревю: </strong>
                                    <small>Моля напиши няколко думи, които да подкрепят поставената оценка.</small>
                                </label>
                                <textarea class='form-control' rows="4" v-model.trim='model.review'></textarea>
                            </div>

                            <div class="col-12 mt-20">
                                <button class='btn btn-info' @click='save'>
                                    {{ hasReview ? "Запази" : "Добави ревю" }}
                                </button>
                            </div>

                        </div>

                    </div>

                </div>
<!-- 
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Затвори</button>
                </div> -->

            </div>
        </div>
    </div>

</div>

</template>

<script>
    export default {

        mounted() {
            this.getData();
        },

        created() {

        },

        props : ['pp'],

        data() {
            return {
                isReady : false,
                hasReview : false,
                model : false,

                rMdl : {
                    project_id : this.pp.project_id,
                    project_phase_id : this.pp.id,
                    c1 : 3,
                    c2 : 3,
                    c3 : 3,
                    rating : 3,
                    review : ''
                }
            }
        },

        methods : {

            openModal() {

                $('#wrmdl').modal('show');

            },

            getData() {
                var me = this;

                me.ajax.call('rvw:gpr', { pp : this.pp.id }, (r) => {

                    if( r.status == 'success' ) {

                        if( r.data ) {
                            
                            me.model = Object.assign({}, me.rMdl, {
                                c1 : r.data.c1,
                                c2 : r.data.c2,
                                c3 : r.data.c3,
                                rating : r.data.rating,
                                review : r.data.review
                            });

                            me.hasReview = true;


                        } else {

                            me.model = Object.assign({}, me.rMdl);

                        }

                        me.isReady = true;

                    }

                });
            },

            save() {

                if( !this.model.review ) {
                    $.notify('Моля въведете текст за ревю','warning');

                    $("#review").focus();

                    return;
                }

                var me = this;

                me.ajax.call('rvw:swr', this.model, (r) => {

                    if( r.status ) {

                        me.hasReview = true;

                        $.notify('Промените бяха запазени','success');
                    }

                });

            },

            checkTotal() {
                if( this.isReady ) {
                    let total = this.model.c1 + this.model.c2 + this.model.c3;

                    this.model.rating = (total / 3).toFixed(2); 
                }
            }



        },

        watch : {

            'model.c1' : function(n,o){
                this.checkTotal();
            },

            'model.c2' : function(n,o){
                this.checkTotal();
            },

            'model.c3' : function(n,o){
                this.checkTotal();
            },

        }
    }
</script>
